import { RootState } from '../store'

const waterFiltrationOptions = (state: RootState) => state.appliances.waterFiltrationOptions
const brands = (state: RootState) => state.appliances.brands
const appliances = (state: RootState) => state.appliances.data



export const AppliancesSelector = {
  waterFiltrationOptions,
  brands,
  appliances,
}